/* @flow */
import Counter from 'components/Counter.jsx';
import MessageDeliverySummary from 'entities/MessageDeliverySummary';
import React from 'react';

import cx from 'classnames';

import './styles/DeliveryModalCounters.scss';

class DeliveryModalCounters extends React.Component {
  static propTypes = {
    summary: React.PropTypes.instanceOf(MessageDeliverySummary).isRequired,
  };

  render() {
    const { summary } = this.props;
    return (
      <div className={cx('DeliveryModalCounters', this.props.className)}>
        <Counter
          className="DeliveryModalCounters-counter"
          value={summary.getFailedCount()}
          label={summary.getFailedCount() === 1 ? 'Error' : 'Errors'}
        />
        <Counter
          className="DeliveryModalCounters-counter"
          value={summary.getReadCount()}
          label="Read"
        />
        <Counter
          className="DeliveryModalCounters-counter"
          value={summary.getSuccessCount()}
          label="Delivered"
        />
      </div>
    );
  }
}

export default DeliveryModalCounters;



// WEBPACK FOOTER //
// ./src/chat/components/DeliveryModalCounters.jsx